// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".submit-error[data-v-109308ac]{color:#9081e6;margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
